export const SIGN_IN_START = "SIGN_IN_START";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_ERROR = "SIGN_IN_ERROR";
export const LOG_OUT = "LOG_OUT";
export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
export const SELECT_PORTAL_TYPE = "SELECT_PORTAL_TYPE";
export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const SHOW_GLOBAL_APP_BAR = "SHOW_GLOBAL_APP_BAR";
